import React from 'react'
import classes from "../style/JobFinderPage.module.css";
import JobFinder from '../JobFinder';
import RightSidebar from '../../../../common/RightSidebar';
import { FullWidthWiraaAds } from '../../../../common/Ads/FullWidthWiraaAds';
import { Helmet } from 'react-helmet';
import JobSearch from '../JobSearch';

const ProjectManagerJob = () => {
  return (
    <div className={classes.page}>
      <Helmet>
                <title>Project Manager Jobs</title>
                <meta name="description" content="Find top Project Manager job opportunities. Plan, execute, and manage projects efficiently in various industries worldwide." />
        </Helmet>
    <div className={classes.container}>
        <h1 className={classes.title}>Project Manager Job Finder</h1>
        <p className={classes.subTitle}>Explore Project Manager Jobs to Lead Teams and Deliver Success</p>
      <JobFinder jobTitle={"Project Manager"}/>
      <JobSearch/>

      <div className={classes.ads}>
        <FullWidthWiraaAds/>
     </div>

      <div className={classes.contentContainer}>
      </div>
    </div>
    <div className={classes.rightsidebar}>
      <RightSidebar/>
    </div>
    </div>
  )
}

export default ProjectManagerJob;
